import React from 'react'
import { array } from 'prop-types'

import Grid from '@/component/Primitive/Grid'

import styles from '../../Footer.module.scss'
import NavigationGroup from '../NavigationGroup'
import SocialLinks from '../SocialLinks'

const Navigation = ({ navItems, socialLinks }) => {
  return (
    <div className={styles.FooterNav}>
      <Grid>
        <Grid.Item hidden="mobile" width={{ d: 1 / 4 }} />
        {navItems &&
          navItems.map(({ title, subItems }, index) => {
            return (
              <Grid.Item key={index} width={{ d: 1 / 4 }}>
                <div className={styles.FooterNavColumn}>
                  <NavigationGroup title={title} content={subItems} />
                </div>
              </Grid.Item>
            )
          })}
        <Grid.Item width={{ d: 1 / 4 }}>
          <SocialLinks socialLinks={socialLinks} />
        </Grid.Item>
      </Grid>
    </div>
  )
}

Navigation.propTypes = {
  navItems: array,
  socialLinks: array
}

export default Navigation
